module.exports = __webpack_public_path__ + "static/valleywise-health-grayscale-ca48e1f4150a0345e4ddd8d85888e6d6.png";